export type VendorRequirementLine = {
  movementId: string;
  tour: string;
  operator: string;
  movement: string;
  pax: number;
  pickup: string;
  pickupDate: string;
  pickupTime: string;
  dropoff: string;
  dropoffDate: string;
  dropoffTime: string;
};

export type VehicleRequirement = { type: string; quantity: number };

export type VendorRequirementBatch = {
  id: string;
  batchCode: string;
  vendorId: string;
  vendorName: string;
  createdAt: string;
  status: "Awaiting Response" | "Available" | "Partially Available" | "Unavailable";
  lines: VendorRequirementLine[];
  vehicleRequirements: VehicleRequirement[];
  notes?: string;
  vendorResponse?: string;
};

const STORAGE_KEY = "fhims_vendor_requirement_batches";
const EVENT_NAME = "fhims-vendor-requirements-updated";

export const loadVendorRequirementBatches = (): VendorRequirementBatch[] => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch {
    return [];
  }
};

export const saveVendorRequirementBatches = (batches: VendorRequirementBatch[]) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(batches));
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
};

export const subscribeVendorRequirementBatches = (listener: () => void) => {
  window.addEventListener(EVENT_NAME, listener);
  window.addEventListener("storage", listener);
  return () => {
    window.removeEventListener(EVENT_NAME, listener);
    window.removeEventListener("storage", listener);
  };
};
